export default {
  USER: "md-person",
  ORG: "md-folder",
  TAG: "md-pricetag"
};